import { render, staticRenderFns } from "./courseData.vue?vue&type=template&id=238adec8&scoped=true&"
import script from "./courseData.vue?vue&type=script&lang=js&"
export * from "./courseData.vue?vue&type=script&lang=js&"
import style0 from "./courseData.vue?vue&type=style&index=0&id=238adec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238adec8",
  null
  
)

export default component.exports